/* -disable import/prefer-default-export */
import styled, { css } from 'styled-components';

export const HeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ alignLeft }) => (alignLeft ? 'start' : 'center')};

  ${({ onChangeDataOrder }) =>
    onChangeDataOrder &&
    css`
      cursor: pointer;

      &:hover {
        color: var(--luft-secondary);

        i {
          color: var(--luft-secondary);
        }
      }
    `}

  i {
    color: var(--light-opacity-gray);
  }
`;

export const BodyRow = styled.tr`
  ${({ hasHover, active }) =>
    hasHover &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${active
          ? 'rgba(16, 119, 185, 0.3)'
          : 'rgba(16, 119, 185, 0.04)'};

        i {
          ${active ? '#0B5583' : 'rgba(16, 119, 185, 0.3)'};
        }
      }
    `}

  ${({ active }) =>
    active &&
    css`
      background-color: rgba(16, 119, 185, 0.3);
      color: white;
    `}
`;
